module.exports = __webpack_public_path__ + "img/德讯证券.ca5fc48f.png";